import {AccommodationPageNavSections} from 'modules/accommodation/types'

export const getScrollTargetRoomsSection = () =>
  AccommodationPageNavSections.Rooms

export const getScrollTargetSpecificRoom = (roomId: string) =>
  `scrollToTarget-roomCard-${roomId}`
